<template>
  <div class="TokenAIVideo">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">AI视频生成</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">AI 视频生成平台是当下热门的智能创作工具，依托前沿多模态技术，打破传统视频制作门槛。这类平台普遍支持文生视频、图生视频、视频续写与画面编辑等功能，可快速生成不同时长、风格的影像内容，部分还搭载自动配音、音画同步、数字人播报等实用能力。如今国内多款平台适配中文创作习惯，操作简洁易上手，兼顾普通爱好者与专业创作者需求。它大幅压缩制作周期、降低人力与设备成本，广泛应用于短视频运营、广告营销、影视创作、知识科普等场景，让创意想法高效落地，已然成为内容生产领域的全新生产力。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/ai-video-homepage.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenAIVideo",
  data() {
    return {
      platformUrl: "https://ai.aobaai.com",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenAIVideo {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/AIVideo.vue